const API = '';

/**
 * Download a file from the API using fetch
 * @param {string} endpoint - API endpoint path (e.g., '/api/reports/template')
 * @param {string} filename - Name for the downloaded file
 * @param {boolean} requiresAuth - Whether the endpoint requires authentication
 */
export async function downloadFile(endpoint, filename, requiresAuth = false) {
  try {
    const url = `${API}${endpoint}`;
    
    const response = await fetch(url, {
      method: 'GET',
      credentials: requiresAuth ? 'include' : 'omit',
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      return { 
        success: false, 
        error: `Download failed: ${response.status}` 
      };
    }
    
    // Get the blob from response
    const blob = await response.blob();
    
    // Create object URL
    const blobUrl = window.URL.createObjectURL(blob);
    
    // Create hidden anchor and trigger download
    const anchor = document.createElement('a');
    anchor.style.display = 'none';
    anchor.href = blobUrl;
    anchor.download = filename;
    
    // Append, click, remove
    document.body.appendChild(anchor);
    anchor.click();
    
    // Cleanup after delay
    setTimeout(() => {
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(blobUrl);
    }, 500);
    
    return { success: true };
  } catch (error) {
    return { 
      success: false, 
      error: error.message || 'Download failed' 
    };
  }
}

/**
 * Alternative: Direct link download (for non-auth endpoints)
 * Opens a hidden iframe to trigger download without leaving the page
 */
export function downloadDirect(endpoint, filename) {
  const url = `${API}${endpoint}`;
  
  // Create a temporary hidden link and click it
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  
  // For modern browsers that support download attribute
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  return { success: true };
}

/**
 * Alternative: Open download in new tab (fallback method)
 */
export function downloadViaNewTab(endpoint) {
  const url = `${API}${endpoint}`;
  window.open(url, '_blank');
  return { success: true };
}
